import axios, { AxiosError } from 'axios';
import { IClient } from '@pec/aion-ui-core/interfaces/client';
import { RootState } from 'combineReducers';
import { sendError } from '@pec/aion-ui-core/sendError';
import { ThunkAction } from 'redux-thunk';

const fetchReleasedClientsWithDashboardRequest = () =>
  ({
    type: 'FETCH_RELEASED_CLIENTS_WITH_DASHBOARD_REQUEST'
  } as const);

const fetchReleasedClientsWithDashboardSuccess = (payload: IClient[]) =>
  ({
    type: 'FETCH_RELEASED_CLIENTS_WITH_DASHBOARD_SUCCESS',
    payload
  } as const);

const fetchReleasedClientsWithDashboardFailure = (error: AxiosError) => {
  sendError(error);
  return {
    type: 'FETCH_RELEASED_CLIENTS_WITH_DASHBOARD_FAILURE',
    error
  } as const;
};

const shouldFetchReleasedClientsWithDashboard = (state: RootState) => !state.releasedClientsWithDashboard.isFetching;

export const fetchReleasedClientsWithDashboard = (
  organizationId: string
): ThunkAction<void, RootState, null, Actions> => async dispatch => {
  try {
    dispatch(fetchReleasedClientsWithDashboardRequest());

    const response = await axios.get<IClient[]>(`/api/v3/rankings/availableClients?contractorId=${organizationId}`);

    dispatch(fetchReleasedClientsWithDashboardSuccess(response.data));
  } catch (error) {
    dispatch(fetchReleasedClientsWithDashboardFailure(error));
  }
};

export const fetchReleasedClientsWithDashboardIfNeeded = (
  organizationId: string
): ThunkAction<void, RootState, null, Actions> => (dispatch, getState) => {
  if (shouldFetchReleasedClientsWithDashboard(getState())) {
    dispatch(fetchReleasedClientsWithDashboard(organizationId));
  }
};

export type Actions =
  | ReturnType<typeof fetchReleasedClientsWithDashboardRequest>
  | ReturnType<typeof fetchReleasedClientsWithDashboardSuccess>
  | ReturnType<typeof fetchReleasedClientsWithDashboardFailure>;
